import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<circle cx=\"8\" cy=\"8\" r=\"8\" style=\"fill:inherit;\" transform=\"matrix(-1 0 0 1 16 0)\"></circle><rect width=\".8\" height=\"6\" fill=\"#fff\" rx=\".4\" transform=\"matrix(-1 0 0 1 11.6 5.2)\"></rect><rect width=\".8\" height=\"4\" fill=\"#fff\" rx=\".4\" transform=\"matrix(-1 0 0 1 10 7.2)\"></rect><rect width=\".8\" height=\"2\" fill=\"#fff\" rx=\".4\" transform=\"matrix(-1 0 0 1 8.4 9.2)\"></rect><rect width=\".8\" height=\"4\" fill=\"#fff\" rx=\".4\" transform=\"matrix(-1 0 0 1 6.8 7.2)\"></rect><rect width=\".8\" height=\"6\" fill=\"#fff\" rx=\".4\" transform=\"matrix(-1 0 0 1 5.2 5.2)\"></rect>", 6)
const _hoisted_8 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_8]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "MOBILE-token"}) } }